import { render } from "./caisse.vue?vue&type=template&id=1463f18d&ts=true"
import script from "./caisse.vue?vue&type=script&lang=ts"
export * from "./caisse.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__